import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';

import { ThemeProvider } from './theme/ThemeProvider';
import Layout from './components/Layout';
import App from './App';
import GraphInfo from './GraphInfo';
import CreateSchema from './components/schema/CreateSchema';
import RunsDashboardPage from './dashboard';
import About from './about';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<App />} />
            <Route path="/GraphInfo" element={<GraphInfo />} />
            <Route path="/CreateSchema" element={<CreateSchema />} />
            <Route path="/dashboard" element={<RunsDashboardPage />} />
            <Route path="/about" element={<About />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
